import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import {type BulkAddMemexItemsResponse, type RepositoryBulkAddMemexItemsRequest, REQUEST_ID_HEADER} from './contracts'

export async function apiRepositoryBulkAddItems(body: RepositoryBulkAddMemexItemsRequest): Promise<[boolean, string]> {
  const apiData = getApiMetadata('memex-item-create-repository-bulk-api-data')
  const {headers} = await fetchJSONWith<BulkAddMemexItemsResponse>(apiData.url, {
    method: 'POST',
    body,
  })

  return [true, headers.get(REQUEST_ID_HEADER) ?? '']
}
